module.exports = __webpack_public_path__ + "img/logo_brick_2.a5ab82c6.png";